import { render, staticRenderFns } from "./viewAward.vue?vue&type=template&id=9da4c524&scoped=true"
import script from "./viewAward.vue?vue&type=script&lang=js"
export * from "./viewAward.vue?vue&type=script&lang=js"
import style0 from "./viewAward.vue?vue&type=style&index=0&id=9da4c524&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da4c524",
  null
  
)

export default component.exports